import {Component, Host, h, JSX, Prop} from '@stencil/core';
import {getTrainCategoryForName} from "../../utils/offers";

@Component({
    tag: 'nj-train-icon',
    styleUrl: 'nj-train-icon.scss',
    shadow: true,
})
export class NjTrainIcon {

    @Prop({mutable: true}) name: string;
    @Prop({mutable: true}) category: string | undefined;
    @Prop({mutable: true}) hideIcon: boolean = false;
    
    render(): JSX.Element | null {
        if (!this.name) {
            return null;
        }

        const trainType = this.category ?? getTrainCategoryForName(this.name);
        return (
            <Host class={{
                'hide-icon': this.hideIcon
            }}>
                {!this.hideIcon && <train-icon aria-hidden="true" class="train-icon-svg" width={20} category={trainType} />}
                <span class={{
                    'train-icon': true,
                    'train-color-default': true,
                    [`train-color-${trainType?.toLowerCase()}`]: !!trainType,
                }}>
                    <span class="train-icon-name">{this.name}</span>
                </span>
            </Host>
        );
    }
}
